<template>
  <div>
    <h3>Account Settings</h3>
    <md-divider></md-divider>
    <password-edit-form/>
  </div>
</template>

<script>
import PasswordEditForm from '../forms/PasswordEditForm.vue'

export default {
  name: 'SettingsAccount',
  components: {
    PasswordEditForm
  }
}
</script>

<style lang="scss" scoped>
  h3 {
    text-align: left;
  }

  .password-edit-form {
    margin-left: -16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/SettingsAccount.vue